const authUser = {
	state: {
		authToken: null,
		emailToken: null,
		authUserDetails: null,
		isSetPassSuccess: false,
		authMessage: {
			status: '',
			message: ''
		}
	},
	mutations: {
		setAuthtoken(state, token) {
			state.authToken = token;
		},
		setEmailToken(state, emailToken) {
			state.emailToken = emailToken;
		},
		setAuthUserDetails(state, details) {
			state.authUserDetails = details;
		},
		clearAuthData(state) {
			state.authToken = null;
			state.emailToken = null;
			state.authUserDetails = null;
		},
		setPassSuccess(state, status) {
			state.isSetPassSuccess = status;
		},
		setAuthMessage(state, authMsg) {
			state.authMessage = {...authMsg};
		}
	},
	actions: {
		setPassMessage({commit, state}) {
			if(state.isSetPassSuccess) {
				commit('setAuthMessage', {
					status: 'success',
					message: 'You may also login using the Mobile App.'
				});
				// Set success Flag to False.
				commit('setPassSuccess', false);

			} else {
				commit('setAuthMessage', {
					status: '',
					message: ''
				});
			}
		}
	},
	getters: {
		getAuthToken(state) {
			return state.authToken;
		},
		getEmailToken(state) {
			return state.emailToken;
		},
		getAuthUserDetails(state) {
			return state.authUserDetails;
		},
		getAuthMessage(state) {
			return state.authMessage;
		}
	}
};

export default authUser;
